<div class="container">
    <div class="half-container">
      <p class="title">{{'TITLE_HEAD_CONTROL_TOWERS' | translate }}</p>
      <p class="subtitle">{{"SUBTITLE_HEAD_CONTROL_TOWERS" | translate}}</p>
    </div>
    <div class="half-container">
     
         <!--- <div class="row">
         
          
            <div class="column">
              
            
             
              <mat-form-field fxFlex="50"  appearance="one-quarter">
            
           
                <mat-icon  matPrefix>search</mat-icon>
                <input class="fieldsearch"    matInput [ngModel]="search" name= "search">
                
                
                </mat-form-field>
                <button  class="matbtnSearch" mat-raised-button fxFlex="50"  class="custom-button">Search</button>
                
            </div>
          
            
        </div>-->
        
        
    </div>
    




</div>




<div class="containerDiv">
    <div class="three-quarters">
      <!-- Contenido para la sección de tres cuartos -->
      
<div class="containerHeaderIncident">
        
  <div class="half-container">
    <div class="headerBack"  (click)="openDialog()">
    <img src="/assets/images/controlTowers/icon_back_blue.svg" height="15" width="15" alt="Imagen">
    <p class="titleback">{{'INCIDENTS_ALERTS_BACK' | translate}}</p>
    </div>
    
      <p class="titleIncident">{{'INCIDENT_FORM_TITLE'| translate}}</p>

     

  </div>
  <div class="half-container">
    
      
      <div fxLayout="row" fxLayoutGap="20px"  fxLayout.xs="column">
         
          <button class="matbtnexit" mat-stroked-button (click)="checkFormIncident(1)">{{ 'BTN_SAVE_EXIT' | translate}}</button>
          <button  mat-raised-button (click)="openDialogCloseIncident()">{{'BTN_SAVE_CONTINUE' | translate}}</button>
         
          
         
         
         
          
      </div>
 
  </div>
</div>
      <neoris-incident-form></neoris-incident-form>
     
     
    </div>
    <div class="one-quarter">
      <!-- Contenido para la sección de un cuarto -->
      <div class="divcontainerLine">
        <div class="line">
        
        </div>

        <neoris-incident-record [Mode]="'embed'" [Data]="incidentRecordData"></neoris-incident-record>
       
      </div>

     
      
    </div>
  </div>

  